import { readCompanyVideoDraft, type VideoDraftInput } from "./video-draft";
import { readCompanyContinueClip } from "./continue-clip";

/** An image is independent of the playhead; retain its cut identity and insertion point. */
export function imageCutDraft(document: unknown, clipId: string): VideoDraftInput {
  const clip = readCompanyContinueClip(document, clipId);
  if (clip.type !== "image") throw Error("이미지 클립을 선택해 주세요.");
  const input: VideoDraftInput = {
    source: { type: "cut", clipId, frame: "end" },
    movement: 0,
    customPrompt: "",
    from: clip.placeAfterFrame,
    fps: clip.fps,
  };
  return { ...input, expectedSourceSignature: readCompanyVideoDraft(input, document).sourceSignature };
}
/** Capture the clicked clip and playhead; later playhead movement must not change the chosen source. */
export function currentFrameDraft(
  document: unknown,
  clipId: string,
  playheadFrame: number,
): VideoDraftInput {
  const doc = document as {
    items?: Record<
      string,
      { type?: string; from: number; durationInFrames: number }
    >;
    fps: number;
  };
  const clip = doc?.items?.[clipId];
  if (clip?.type !== "video") throw Error("영상 클립을 선택해 주세요.");
  const input: VideoDraftInput = {
    source: { type: "cut", clipId, frame: "playhead", playheadFrame },
    movement: 0,
    customPrompt: "",
    from: clip.from + clip.durationInFrames,
    fps: doc.fps,
  };
  const captured = readCompanyVideoDraft(input, document);
  return { ...input, expectedSourceSignature: captured.sourceSignature };
}
